import visangLogo from '@/shared/publish/ui/assets/images/ttukttak/common/icon/logo.svg';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footerWrap">
                <h2>
                    <img src={visangLogo} alt="비상" />
                </h2>
                <div className="info">
                    <ul>
                        <li>
                            <a
                                href="https://www.visang.com/pageLoad?page_id=kr/main"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                회사소개
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.vivasam.com/support/question/form"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                문의하기
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.vivasam.com/support/contact/list"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                찾아오시는 길
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.vivasam.com/public/terms"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                이용약관
                            </a>
                        </li>
                        <li>
                            <a href="https://www.vivasam.com/public/privacy" className="bold">
                                개인정보처리방침
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://e.vivasam.com/sitemap"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                사이트맵
                            </a>
                        </li>
                    </ul>
                    <span>㈜비상교육 대표자명 : 양태회</span>
                    <span>사업자등록번호 : 211-87-07735</span>
                    <br />
                    <span>경기 과천시 과천대로2길 54 그라운드브이 14층</span>{' '}
                    <span>TEL : 1544-7714(선생님 전용 고객센터)</span>
                    <p className="copy">COPYRIGHT(C) (주)비상교육 ALL RIGHTS RESERVED.</p>
                </div>
                {/* <!-- 25.02.24 추가 --> */}
                {/*<div className="btns">*/}
                {/*    <a*/}
                {/*        href="http://bookstore.visang.com/BookStore_list.asp?CateCode=BS0801&MGubun=X"*/}
                {/*        target="_blank"*/}
                {/*        className="btn_buy"*/}
                {/*    >*/}
                {/*        교과서/지도서 구매*/}
                {/*    </a>*/}
                {/*    <div className="slt">*/}
                {/*        <p className="t">*/}
                {/*            <a href="#">*/}
                {/*                <span>FAMILY SITE</span>*/}
                {/*            </a>*/}
                {/*        </p>*/}
                {/*        <div style={{ display: 'none' }}>*/}
                {/*            <ul>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="http://www.visang.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="비상교육(주)"*/}
                {/*                    >*/}
                {/*                        비상교육(주)*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <span>출판교육서비스</span>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="http://textbook.visang.com/"*/}
                {/*                        target="_blank"*/}
                {/*                        title="비상교과서"*/}
                {/*                    >*/}
                {/*                        비상교과서*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="http://book.visang.com/"*/}
                {/*                        target="_blank"*/}
                {/*                        title="비상교재"*/}
                {/*                    >*/}
                {/*                        비상교재*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://t.vivasam.com/"*/}
                {/*                        target="_blank"*/}
                {/*                        title="비바샘 원격교육연수원"*/}
                {/*                    >*/}
                {/*                        비바샘 원격교육연수원*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="http://bookstore.visang.com/BookStore_list.asp?CateCode=BS0801&MGubun=X"*/}
                {/*                        target="_blank"*/}
                {/*                        title="비상서점"*/}
                {/*                    >*/}
                {/*                        비상서점*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <span>에듀플랫폼</span>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.only1.co.kr/"*/}
                {/*                        target="_blank"*/}
                {/*                        title="온리원"*/}
                {/*                    >*/}
                {/*                        온리원*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://kids.only1.co.kr"*/}
                {/*                        target="_blank"*/}
                {/*                        title="온리원 키즈"*/}
                {/*                    >*/}
                {/*                        온리원 키즈*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.pionada.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="피어나다"*/}
                {/*                    >*/}
                {/*                        피어나다*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.allviaedu.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="올비아"*/}
                {/*                    >*/}
                {/*                        {' '}*/}
                {/*                        올비아*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.masterTOPIK.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="마스터토픽"*/}
                {/*                    >*/}
                {/*                        마스터토픽*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.masterkorean.vn/"*/}
                {/*                        target="_blank"*/}
                {/*                        title="마스터코리안"*/}
                {/*                    >*/}
                {/*                        마스터코리안*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <span>교육기관</span>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.englisheye.co.kr"*/}
                {/*                        target="_blank"*/}
                {/*                        title="마스터코리안"*/}
                {/*                    >*/}
                {/*                        잉글리시아이*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.visangelif.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="엘리프어학원"*/}
                {/*                    >*/}
                {/*                        엘리프어학원*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://www.ebsnurisam.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="EBS누리샘"*/}
                {/*                    >*/}
                {/*                        EBS누리샘*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://tikitoki.ebsnurisam.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="티키토키"*/}
                {/*                    >*/}
                {/*                        티키토키*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="https://brand.soohakplus.com/Intro/Default.aspx"*/}
                {/*                        target="_blank"*/}
                {/*                        title="수학플러스러닝"*/}
                {/*                    >*/}
                {/*                        수학플러스러닝*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="http://www.ivytz.com"*/}
                {/*                        target="_blank"*/}
                {/*                        title="비상아이비츠"*/}
                {/*                    >*/}
                {/*                        비상아이비츠*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <span>학부모교육/교육문화체험</span>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="http://www.jumpsky.co.kr"*/}
                {/*                        target="_blank"*/}
                {/*                        title="점프스카이"*/}
                {/*                    >*/}
                {/*                        점프스카이*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <span>인쇄시설</span>*/}
                {/*                </li>*/}
                {/*                <li>*/}
                {/*                    <a*/}
                {/*                        href="http://www.terabooks.co.kr"*/}
                {/*                        target="_blank"*/}
                {/*                        title="테라북스"*/}
                {/*                    >*/}
                {/*                        테라북스*/}
                {/*                    </a>*/}
                {/*                </li>*/}
                {/*            </ul>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </footer>
    );
};

export default Footer;
